import { UserProfile } from 'Domain/User/Entity/UserProfile';
import executeRequest from 'Infrastructure/WebClient';
import * as RequestTypes from 'Application/RequestTypes';
import { DebtorRequest } from 'Domain/User/Dto/DebtorRequest';

export function getDebtorProfile(id: string) {
  return executeRequest<UserProfile>(RequestTypes.DEBTOR_GET, [], {
    id: id,
  }).then((res) => {
    // if ('mobile' in res) {
    //   res.mobile = res.mobile.slice(3);
    // }
    // if ('phone' in res) {
    //   res.phone = res.phone.slice(3);
    // }

    return res;
  });
}

export function createDebtor(debtorRequest: DebtorRequest) {
  return executeRequest<UserProfile>(
    RequestTypes.DEBTOR_CREATE,
    debtorRequest,
  ).then((res) => {
    return res;
  });
}

export function updateDebtor(id: string, debtorRequest: DebtorRequest) {
  return executeRequest<UserProfile>(
    RequestTypes.DEBTOR_UPDATE,
    debtorRequest,
    { id: id },
  ).then((res) => {
    return res;
  });
}
